import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";

/**
 * @function urlIsAVidyardAddress Returns whether the URL is a Vidyard address
 * @param url
 */
export const urlIsAVidyardAddress: (url: string) => boolean = (url: string) => {

  // get the regular expression pattern for the website
  const regEx: RegExp = RegularExpressions.Vidyard;

  // return the result of testing the given url against the regex pattern
  return regEx.test(url);
}
